export const TOOLTIP = {
  serviceRequired: [
    "Regular, 10 business days",
    "Express, 30% faster",
    "Shuttle, 60% faster",
  ],
};
